import "./Solucao.css";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import fotoDrBruno1 from "../../assets/img/fotoDrBruno1.png";

function Solucao() {
  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

 return (
    <section className="solucao-section">
      <div className="container">

        <h2 className="solucao-title text-center scroll-reveal-opacity">
          CHEGA DE SOLUÇÕES TEMPORÁRIAS
        </h2>

        <div className="row g-4">

          {/* CARD 1 */}
          <div className="col-12 col-md-4 scroll-reveal-opacity">
            <div className="solucao-card">
              <span className="material-symbols-outlined solucao-icon">
                settings_accessibility
              </span>
              <h3>Funcionalidade</h3>
              <p>
                Recupere sua rotina e as funções essenciais do seu corpo com precisão cirúrgica.
              </p>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-12 col-md-4 scroll-reveal-opacity">
            <div className="solucao-card">
              <span className="material-symbols-outlined solucao-icon">
                diversity_3
              </span>
              <h3>Segurança Social</h3>
              <p>
                Volte a conviver em ambientes sociais sem o medo ou a insegurança de condições debilitantes.
              </p>
            </div>
          </div>

          {/* CARD 3 */}
          <div className="col-12 col-md-4 scroll-reveal-opacity">
            <div className="solucao-card">
              <span className="material-symbols-outlined solucao-icon">
                clinical_notes
              </span>
              <h3>Dignidade</h3>
              <p>
                Resgate sua autoestima e sua identidade através de um tratamento humano e resolutivo.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Solucao;